jQuery(document).ready(function($) {
  $('.logos__wrapper').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  const init = {
    autoplay: true,
    arrows: false,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  $(() => {
    const win = $(window);
    const slider = $(".custom_announcement_bar .cab_items");
  
    win.on("load resize", () => {
      if (win.width() < 1024) {
        slider.not(".slick-initialized").slick(init);
      } else if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    });
  });

  setTimeout(function() {
        $('.custom_announcement_bar').css('visibility', 'visible');
    }, 900);


$( document ).ready(function() {
    $(".swatch .swatch-element label").click(function(){
      console.log();
      var s_value = $(this).parent().attr('data-value');

      $(".cust_color").find('.select__select').val(s_value).trigger('change');
      
      //$(".cust_color .select__select option").removeAttr('selected');
      $(".cust_color .select__select option").each(function(index) {
        
        // if(s_value == this.value){
        //   //$(this).attr('selected','selected');

        //   jQuery(this).eq(index).val(this.value).trigger('change');
          
        //   console.log(this.text + ' ' + this.value);
        //   // $(this).trigger('change');
        //   // $(this).change();
        //   // //$(this).select();
        //   // $(this).trigger('click');
        //   // $(this).click();

        //   // $(".cust_color .select__select").trigger('change');
        //   // $(".cust_color .select__select").change();
        //   // //$(this).select();
        //   // $(".cust_color .select__select").trigger('click');
        //   // $(".cust_color .select__select").click();
          
        // }
      });
    });
});
$(".scroll_to").click(function() {
    $('html, body').animate({
        scrollTop: $(".des_scroll").offset().top
    }, 100);
});

$("details.megamenu-open").hover(function(){
    $(this).attr("open", "open");
    }, function(){
    $(this).removeAttr("open");
  });
  
});






